import { extendTheme } from "@chakra-ui/react";

// Color mode configuration
const config = {
  initialColorMode: "light", // Force light mode by default
  useSystemColorMode: false, // Ignore system/browser dark mode
};

// Custom theme colors for both light and dark mode
const theme = extendTheme({
  config,
  fonts: {
    heading: `'Gilroy', sans-serif`,
    body: `'Gilroy', sans-serif`,
  },
  colors: {
    dentacasa: {
      50: "#e6e6ff",
      100: "#b7b7fc",
      200: "#8787f7",
      300: "#5857f3",
      400: "#2b29ef",
      500: "#1410d5",
      600: "#0e0ca7",
      700: "#080878",
      800: "#03054a",
      900: "#01011d",
    },
    // Define light and dark mode colors
    light: {
      white: "#fff", // Light mode background color
      text: "#150A40", // Light mode text color
      primary: "#2b29ef", // Light mode primary color
    },
    dark: {
      white: "#171717", // Dark mode background color
      text: "#ffffff", // Dark mode text color
      primary: "#1410d5", // Dark mode primary color
    },
  },
});

export default theme;
